module.exports = __webpack_public_path__ + "static/media/bg_nextgen_mob_xbox.ac90ee7e.jpg";